import React, { Component } from 'react';

import EirButton from '../eir-button/EirButton';

class FooterLinksBottom extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <li className="list-inline-item ">
      {this.props.link &&
        <EirButton
          {...this.props.link}
          className={'footer-links-bottom'}
        />}
      </li>
    );
  }
}

export default FooterLinksBottom;
